import { capitalCase } from 'change-case'
export default {
    data: () => ({
        /*  permissionSections: [
            'Audit Logs',
            'Customers',
            'Dashboard',
            'Fleet',
            'Item Types',
            'Assigned Exception',
            'Orders',
            'Order Items',
            'Order Types',
            'Reports',
            'Roles',
            'Settings',
            'Users',
            'Assets',
            'Asset Types',
            'Asset Vendors',
            'Locations',
            'Master Items',
            'Order Categories',
            'Order Templates',
            'Request Categories',
            'Review Templates',
            'Review Types',
        ], */
        permissionTypes: ['Create', 'View', 'Update', 'Delete'],
        permissionSection: null,
    }),
    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        permissionSections() {
            const routes = this.$router.options.routes || []
            const dashboardLayout = routes.find(
                x => x.name === 'dashboardLayout'
            )
            const _sections = (dashboardLayout.children || [])
                .filter(x => x.meta && x.meta.group)
                .map(x => capitalCase(x.name))
            ///for mobile permissions
            _sections.push('Assigned Exception')
            console.log('permission sections', _sections)
            return _sections
        },
    },

    created() {
        const section = this.$options.name
        console.log('section', section)
    },

    methods: {
        setPermissionSecttion(section) {
            if (!this.permissionSections.includes(section))
                throw new Error('Illegal Permission Section')
            this.permissionSection = section
        },
        hasPermissionCreate() {
            return this.hasPermissionSectionAction('create')
        },

        hasPermissionView() {
            return this.hasPermissionSectionAction('view')
        },

        hasPermissionUpdate() {
            return this.hasPermissionSectionAction('update')
        },

        hasPermissionDelete() {
            return this.hasPermissionSectionAction('delete')
        },

        hasPermissionAction(action) {
            if (!this.permissionSection) return false
            if (!this.permissionSections.includes(this.permissionSection))
                return false
            const section = this.permissionSection
                .toLowerCase()
                .split(' ')
                .join('.')
            return this.user_permissions.includes(`${action}.${section}`)
        },
    },
}
